import $ from 'jquery';

const createMuiTheme = innerTheme => outerTheme => {
  let theme = {};
  $.extend(true, theme, outerTheme, innerTheme);
  return theme;
};

export default createMuiTheme;
